import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// navigator.onLine is unreliable in these browsers, so we assume they are always online.
const UNRELIABLE_USER_AGENTS_PATTERN = /Windows.*Chrome|Windows.*Firefox|Linux.*Chrome/
const isUnsupportedUserAgent = () => UNRELIABLE_USER_AGENTS_PATTERN.test(navigator.userAgent)

const getInitialOnlineStatus = () => {
  if (isUnsupportedUserAgent()) return true

  return typeof navigator.onLine === 'boolean' ? navigator.onLine : true
}

const useOnlineStatus = () => {
  const [online, setOnline] = useState(getInitialOnlineStatus)

  useEffect(() => {
    if (isUnsupportedUserAgent()) return

    const goOnline = () => setOnline(true)
    const goOffline = () => setOnline(false)

    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)

    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  return online
}

const ConnectivityGuard = ({ children, fallback }) => {
  const online = useOnlineStatus()

  return online ? children : fallback
}

ConnectivityGuard.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node.isRequired
}

export default ConnectivityGuard
